(() => {
  const applyComingSoonLabels = () => {
    const children = document.querySelectorAll('.mobile-nav__item--case-studies .mobile-nav__child-link');
    children.forEach((link) => {
      const label = (link.textContent || '').replace(/\s*\(COMING SOON\)\s*$/i, '').trim();
      if (label && label.toUpperCase() !== 'CASE STUDY 04') {
        link.textContent = label + ' (COMING SOON)';
        link.setAttribute('aria-disabled', 'true');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyComingSoonLabels);
  } else {
    applyComingSoonLabels();
  }
})();
